/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebkassaFiscalResult { 
    type?: string;
    fiscalDate?: string;
    cashboxFactoryNumber?: string;
    cashboxRegistrationNumber: string;
    cashboxIdentificationNumber?: string;
    fiscalNumber?: string;
    taxType?: string;
    taxSeries?: string;
    taxNumber?: string;
}

